export function Home() {
  return (
    <div className="home">
      <h1>BB Docs</h1>
      <p>Select a page from the sidebar or create a new one.</p>
    </div>
  );
}
